module.exports = __webpack_public_path__ + "static/img/haoqititle.a5c3f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/haoqititle.png
// module id = y81m
// module chunks = 0